import { MutableRefObject, useEffect, useRef } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'

export type MemoAndReturn<T> = [MutableRefObject<T>, T]

export const useMemoRef = <T extends unknown>(memoGenerator: () => T, ...args: unknown[]): MutableRefObject<T> => {
    const state: MutableRefObject<T> = useRef<T>(memoGenerator())

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect(() => {
        if (isMounted.current) {
            state.current = memoGenerator()
        }
    }, [...args])

    return state
}

export const useMemoRefAndReturn = <T extends unknown>(
    memoGenerator: () => T,
    ...args: unknown[]
): MemoAndReturn<T> => {
    const state: MutableRefObject<T> = useRef<T>(memoGenerator())

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect(() => {
        if (isMounted.current) {
            state.current = memoGenerator()
        }
    }, [...args])

    return [state, state.current]
}
